import { createFileRoute, redirect } from "@tanstack/react-router";
import { getRapportFlowData } from "#/modules/rapporten/rapporten.functions";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/reports/flow/$id/step/3/",
)({
  loader: async ({ params }) => {
    const { rapport } = await getRapportFlowData({ data: { rapportId: params.id } });

    if (!rapport?.klassen?.length) {
      throw redirect({
        to: "/$locale/{-$schoolyear}/$school/reports/flow/$id/step/2",
        params: {
          locale: params.locale,
          schoolyear: params.schoolyear,
          school: params.school,
          id: params.id,
        },
      });
    }

    const firstKlas = rapport.klassen[0];
    if (!firstKlas) {
      throw redirect({
        to: "/$locale/{-$schoolyear}/$school/reports/flow/$id/step/2",
        params: {
          locale: params.locale,
          schoolyear: params.schoolyear,
          school: params.school,
          id: params.id,
        },
      });
    }

    throw redirect({
      to: "/$locale/{-$schoolyear}/$school/reports/flow/$id/step/3/$class",
      params: {
        locale: params.locale,
        schoolyear: params.schoolyear,
        school: params.school,
        id: params.id,
        class: firstKlas.id,
      },
    });
  },
});
